import React from 'react'
import '../pages.css'
import logoExpansao from '../../images/logo-padrao.png'
import logoSF from '../../images/Sala do Futuro - Positivo.png'
import Cabecalho from '../../components/Cabecalho'
import Rodape from '../../components/Rodape'

const Home = ()=>{

    const handleRedirect = ()=>{
        window.location.replace('https://saladofuturo.educacao.sp.gov.br/');
    }
    return (
        <>
            <link rel="stylesheet" type="text/css" href="https://saopaulo.sp.gov.br/barra-govsp/css/top-padrao-govsp-v2.min.css?vs=3.0"></link>
            <Cabecalho/>
            <div className='container_warn'>
                <div className='container_logos'>
                    <img src={logoExpansao} className='logo_expansao_warn' alt='logo Moodle Expansão' />
                </div>
                <div className='container_title'>
                    Como acessar    
                </div>
                <div className='container_text'>
                    Para acessar corretamente, siga os passos:<br/><br/>

                    1. Acesse a <b>Sala do Futuro</b> e faça login (utilize o botão abaixo);<br/><br/>

                    2. No menu, clique em <b>"Plataformas de Aprendizagem"</b>;<br/><br/>

                    3. Encontre a turma de Expansão através do filtro;<br/><br/>

                    4. Clique no card <b>"Expansão"</b>.<br/><br/>
                    
                    <div className='container_btn_sf'>
                        <button id='btn_sf' onClick={handleRedirect} >
                            <img id='logo_sf' src={logoSF} alt='logo Sala do Futuro' />
                        </button>
                    </div>

                    Caso tenha dúvidas, entre em contato com o suporte através do <a href='https://atendimento.educacao.sp.gov.br/'>portal de atendimento</a>.
                </div>
                                
            </div>
            <Rodape/>
        </>
    
)
}

export default Home